module.exports = __webpack_public_path__ + "static/media/u36_3.17a02bae.mp3";